import { getBootstrapData } from "@swa-ui/bootstrap";
import { dateFormats, swaDate } from "@swa-ui/date";
import { createHrefWithSearchParams } from "@swa-ui/href";

export const getCarBookingSearchHref = (formData) => {
  const {
    driverAge,
    int,
    pickupDate,
    pickupLocation,
    pickupTime,
    rentalCompany,
    returnDate,
    returnLocation,
    returnTime,
    searchParams = {},
    vehicleSize,
  } = formData;
  const { CAR_BOOKING_SELECT_PAGE } = getBootstrapData("urls");

  const queryParams = {
    carType: vehicleSize,
    driverAge,
    int,
    pickUpDate: swaDate(pickupDate).format(dateFormats.iso),
    pickUpLocation: pickupLocation,
    pickUpTime: swaDate(pickupTime, "h:mma").format("HH:mm"),
    returnDate: swaDate(returnDate).format(dateFormats.iso),
    returnLocation,
    returnTime: swaDate(returnTime, "h:mma").format("HH:mm"),
    vendors: rentalCompany,
    ...searchParams,
  };

  return createHrefWithSearchParams(CAR_BOOKING_SELECT_PAGE, queryParams).href;
};
